import React from 'react'
import { useTranslation } from 'react-i18next'
import { memo } from '~/ui/component'
import { TextBlock, VBox } from '~/ui/components'
import { BeWizrTile } from '../bewizr'
import BeWizrCourseProgressBar from './BeWizrCourseProgressBar'

export interface Props {
  label?:       string
  title:        string
  slug:         string
  image:        string | null
  progress:     number | null | false
  description?: string | null
  locked?:      boolean
  horizontal?:  boolean
}

const BeWizrCourseTile = memo('BeWizrCourseTile', (props: Props) => {

  const {label, title, slug, image, progress, description, horizontal, locked} = props

  const [t] = useTranslation('bewizr-courses')

  //------
  // Rendering

  function render() {
    return (
      <BeWizrTile
        icon='course'
        label={label}
        title={title}
        href={`/bewizr-courses/-/${slug}`}
        image={image}
        children={renderContent()}
        buttonCaption={t('view')}
        horizontal={horizontal}
        locked={locked}
      />
    )
  }

  function renderContent() {
    if (progress === false && description == null) { return null }

    return (
      <VBox>
        {renderDescription()}
        {renderProgress()}
      </VBox>
    )
  }

  function renderProgress() {
    if (progress === false) { return null }
    return (
      <BeWizrCourseProgressBar
        progress={progress ?? 0}
      />
    )
  }

  function renderDescription() {
    if (description == null) { return null }

    return (
      <TextBlock small dim>
        {description}
      </TextBlock>
    )
  }


  return render()

})

export default BeWizrCourseTile